import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls an element into view when the URL hash matches the specified hash.
 * @param elementId The ID of the element to scroll to.
 * @param targetHash The hash value (including #) that triggers the scroll.
 * @param options ScrollIntoView options.
 * @param delay Optional delay in ms before scrolling.
 */
export function useScrollToElementOnHashChange(
  elementId: string,
  targetHash: string,
  options: ScrollIntoViewOptions = { behavior: "smooth", block: "end" },
  delay = 50
) {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === targetHash) {
      const timer = setTimeout(() => {
        const container = document.getElementById(elementId);
        if (container) {
          container.scrollIntoView(options);
        }
      }, delay);
      return () => clearTimeout(timer);
    }
  }, [location.hash, elementId, targetHash, options, delay]);
}
